"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("antd/es/list/style/css");

var _list = _interopRequireDefault(require("antd/es/list"));

require("antd/es/button/style/css");

var _button = _interopRequireDefault(require("antd/es/button"));

require("antd/es/form/style/css");

var _form = _interopRequireDefault(require("antd/es/form"));

var _react = _interopRequireWildcard(require("react"));

var _collapse = _interopRequireDefault(require("antd/lib/collapse"));

var _uuid = _interopRequireDefault(require("uuid"));

var _icons = require("@ant-design/icons");

var _ScreenerOptionGroup = _interopRequireDefault(require("./ScreenerOptionGroup"));

var _ScreenerQuestionItem = _interopRequireDefault(require("./ScreenerQuestionItem"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

const {
  Item
} = _form.default;

class ScreenerQuestionForm extends _react.Component {
  constructor(props) {
    super(props);
    this.styles = {
      item: {
        width: '100%',
        marginBottom: '10px',
        marginTop: '10px'
      },
      addButton: {
        width: '200px',
        color: '#439AFF',
        borderColor: '#439AFF',
        backgroundColor: '#D0E6FF',
        marginTop: '5px',
        marginBottom: '5px'
      }
    };

    this.addQuestion = () => {
      const {
        questions
      } = this.state;
      const newUUID = (0, _uuid.default)();
      this.setState({
        questions: new Map(questions.set(newUUID, {
          uuid: newUUID,
          text: ''
        })),
        isUnsaved: true
      });
    };

    this.updateQuestion = question => {
      const {
        questions
      } = this.state;
      this.setState({
        questions: new Map(questions.set(question.uuid, { ...question
        })),
        isUnsaved: true
      });
    };

    this.removeQuestion = uuid => {
      const {
        questions
      } = this.state;
      questions.delete(uuid);
      this.setState({
        questions: new Map(questions),
        isUnsaved: true
      });
    };

    this.addOption = optionGroupId => {
      const {
        optionGroups,
        options
      } = this.state;
      const groupToAdd = optionGroups.get(optionGroupId);
      const newUUID = (0, _uuid.default)();

      if (groupToAdd) {
        this.setState({
          optionGroups: new Map(optionGroups.set(optionGroupId, [...groupToAdd, newUUID])),
          options: new Map(options.set(newUUID, {
            uuid: newUUID,
            text: '',
            optionGroupId
          })),
          isUnsaved: true
        });
      }
    };

    this.updateOption = option => {
      const {
        options
      } = this.state;
      this.setState({
        options: new Map(options.set(option.uuid, { ...option
        })),
        isUnsaved: true
      });
    };

    this.removeOption = uuid => {
      const {
        options,
        optionGroups
      } = this.state;
      const optionToDelete = options.get(uuid);

      if (optionToDelete) {
        options.delete(uuid);

        if (optionToDelete.optionGroupId) {
          // this.removeOptionGroup calls this method which means the optionGroup may already
          // have been deleted, so this logic ensures that we only update the optionGroup if
          // it hasn't been deleted yet
          const groupToDeleteFrom = optionGroups.get(optionToDelete.optionGroupId);

          if (groupToDeleteFrom) {
            this.setState({
              optionGroups: new Map(optionGroups.set(optionToDelete.optionGroupId, groupToDeleteFrom.filter(id => id !== uuid)))
            });
          }
        }

        this.setState({
          options: new Map(options),
          isUnsaved: true
        });
      }
    };

    this.addOptionGroup = () => {
      const {
        optionGroups
      } = this.state;
      this.setState({
        optionGroups: new Map(optionGroups.set((0, _uuid.default)(), []))
      });
    };

    this.removeOptionGroup = optionGroupId => {
      const {
        optionGroups
      } = this.state;
      const optionsToRemove = optionGroups.get(optionGroupId);

      if (optionsToRemove && optionsToRemove.length > 0) {
        optionsToRemove.forEach(uuid => this.removeOption(uuid));
      }

      optionGroups.delete(optionGroupId);
      this.setState({
        optionGroups: new Map(optionGroups)
      });
    };

    this.validateQuestions = (rule, value) => {
      try {
        const {
          questions
        } = this.state;

        if (questions.size === 0) {
          throw new Error('No questions defined.');
        }

        questions.forEach(q => {
          if (!q.optionGroupId) {
            throw new Error('All questions must be assigned a group ID.');
          }
        });
        return Promise.resolve();
      } catch (err) {
        return Promise.reject(err);
      }
    };

    const {
      questions,
      options
    } = props;
    const defaultState = {
      optionGroups: new Map(),
      questions: new Map(),
      options: new Map(),
      isUnsaved: false
    }; // Adding options passed in through props to the state options Map
    // and building option groups map

    if (options && options.length > 0) {
      for (const option of options) {
        // Use existing id/uuid when possible, otherwise, generate a new one
        const optionReferenceUUID = option.uuid || (option.id ? option.id.toString() : (0, _uuid.default)());
        defaultState.options.set(optionReferenceUUID, { ...option,
          uuid: optionReferenceUUID
        });

        if (option.optionGroupId) {
          const currentGroup = defaultState.optionGroups.get(option.optionGroupId);

          if (currentGroup) {
            defaultState.optionGroups.set(option.optionGroupId, [...currentGroup, optionReferenceUUID]);
          } else {
            defaultState.optionGroups.set(option.optionGroupId, [optionReferenceUUID]);
          }
        }
      }
    } // If questions are passed in as props, copy those to state and
    // generate UUIDs


    if (questions && questions.length > 0) {
      for (const question of questions) {
        const questionReferenceUUID = question.uuid || (question.id ? question.id.toString() : (0, _uuid.default)());
        defaultState.questions.set(questionReferenceUUID, { ...question,
          uuid: questionReferenceUUID
        });
      }
    }

    this.state = { ...defaultState
    };
  }

  componentDidUpdate(prevProps, prevState) {
    if (!prevState.isUnsaved && this.state.isUnsaved) {
      const {
        questions,
        options
      } = this.state;
      this.props.updateQuestions([...questions.values()]);
      this.props.updateOptions([...options.values()]);
      this.setState({
        isUnsaved: false
      });
    }
  }

  render() {
    const {
      disabled
    } = this.props;
    const {
      questions,
      options,
      optionGroups
    } = this.state;
    const optionSets = [...optionGroups.entries()].map(([optionGroupId, optionIds]) => {
      return [optionGroupId, optionIds.map(id => options.get(id))];
    });
    return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(Item, {
      key: "option-groups",
      label: "Option Groups:",
      style: this.styles.item
    }, /*#__PURE__*/_react.default.createElement(_collapse.default, {
      ghost: true
    }, optionSets.map(([optionGroupId, options], index) => {
      return /*#__PURE__*/_react.default.createElement(_ScreenerOptionGroup.default, {
        key: `option-group-${optionGroupId}`,
        disabledProp: disabled,
        header: `Group ${index}`,
        optionGroupId: optionGroupId,
        options: options,
        addOption: this.addOption,
        updateOption: this.updateOption,
        removeOption: this.removeOption,
        removeGroup: () => this.removeOptionGroup(optionGroupId)
      });
    })), /*#__PURE__*/_react.default.createElement(_button.default, {
      key: "add-option-group",
      disabled: disabled,
      style: this.styles.addButton,
      onClick: this.addOptionGroup,
      type: "dashed",
      title: "Add new option group"
    }, /*#__PURE__*/_react.default.createElement(_icons.PlusOutlined, null), ' ', "Add option group")), /*#__PURE__*/_react.default.createElement(Item, {
      key: "screener-questions",
      name: "screener-questions",
      label: "Questions",
      style: this.styles.item,
      validateTrigger: ['onChange', 'onSubmit', 'onBlur', 'onFocus'],
      rules: [{
        required: true,
        validator: this.validateQuestions
      }]
    }, questions.size > 0 && /*#__PURE__*/_react.default.createElement(_list.default, {
      itemLayout: "horizontal",
      dataSource: [...questions.values()],
      renderItem: q => {
        return /*#__PURE__*/_react.default.createElement(_ScreenerQuestionItem.default, {
          key: `question-item-${q.uuid}`,
          disabled: disabled,
          question: q,
          groups: optionSets,
          updateQuestion: this.updateQuestion,
          removeQuestion: () => this.removeQuestion(q.uuid)
        });
      }
    }), /*#__PURE__*/_react.default.createElement(_button.default, {
      key: "add-question",
      disabled: disabled,
      style: this.styles.addButton,
      onClick: () => this.addQuestion(),
      type: "dashed",
      title: "Add new question"
    }, /*#__PURE__*/_react.default.createElement(_icons.PlusOutlined, null), ' ', "Add question")));
  }

}

var _default = ScreenerQuestionForm;
exports.default = _default;